<div class="sh-form-tag-list">
    <div class="sh-form-tag-list__input" (shClickOutside)="closeDroppanel()">
        @if (addActionItem$ | async; as actionItem) {
            <div class="sh-input-field-with-action" [class.-sh-joined-action]="actionItem.location === actionLocation.Joined">
                <div class="sh-input-field-with-action__input">
                    <div class="sh-form-multiselect">
                        <div style="display: flex">
                            <!-- Used for adding dropdown for search-bar mode selection for example -->
                            <ng-content></ng-content>
                            @if (styling.style === "Embedded") {
                                <sh-tag-list
                                    [id]="id"
                                    [tags]="filteredState$ | async"
                                    [disabled]="disabled"
                                    [editable]="editable"
                                    [styling]="styling"
                                    [limitedButtons]="limitedButtons()"
                                    (onTagsUpdate)="onTagsEdit($event)"
                                    (onTagRemove)="removeTag($event)"
                                >
                                    <li embeddedInput class="sh-form-tag-list__inline-input">
                                        <ng-container *ngTemplateOutlet="inputField"></ng-container>
                                        <div class="sh-form-tag-list__inline-input__highlight"></div>
                                    </li>
                                </sh-tag-list>
                            } @else {
                                <input
                                    #searchInput
                                    type="text"
                                    [formControl]="tagInputControl"
                                    [id]="id"
                                    class="sh-input-field sh-form-group__input"
                                    [class.-sh-remove-border]="styling.modifiers.indexOf(formTagListStyleModifier.NoBorder) >= 0"
                                    (keyup.enter)="onEnter($event)"
                                    (keyup.backspace)="onBackspace()"
                                    [attr.placeholder]="placeholder || null"
                                    [attr.aria-describedBy]="invalid ? describeLabelId : null"
                                    [attr.aria-invalid]="invalid"
                                    [attr.autocomplete]="autocomplete"
                                    [attr.disabled]="disabled ? true : null"
                                    [maxlength]="_maxLength"
                                    (focus)="onSearchFocus()"
                                />
                            }
                        </div>
                        <ng-container *ngTemplateOutlet="suggestions"></ng-container>
                    </div>
                </div>
                @if (actionItem.location !== actionLocation.None) {
                    <sh-action-item [item]="actionItem" class="sh-input-field-with-action__action"></sh-action-item>
                }
            </div>
        }

        @if ((hasDuplicateInput$ | async) && duplicateErrorMsg !== "") {
            <p class="sh-form-group__feedback">{{ duplicateErrorMsg }}</p>
        }
        @if (invalid) {
            <p [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
        }
        @if (isIndeterminate$ | async) {
            <p class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
        }
    </div>
    @if (styling.style !== "Embedded") {
        <sh-tag-list
            [id]="id"
            [tags]="filteredState$ | async"
            [disabled]="disabled"
            [editable]="editable"
            [styling]="styling"
            [limitedButtons]="limitedButtons()"
            (onTagsUpdate)="onTagsEdit($event)"
            (onTagRemove)="removeTag($event)"
        ></sh-tag-list>
    }
</div>

<ng-template #suggestions>
    @if (suggestions$ | async; as suggestions) {
        @if (suggestions.length !== 0) {
            <div class="sh-droppanel sh-form-tag-list__droppanel" [ngClass]="droppanelStyle" [class.-sh-is-open]="droppanelOpen">
                <ul class="sh-droppanel__list">
                    @for (suggestion of suggestions; track suggestion) {
                        <li class="sh-droppanel__list__item">
                            <button
                                #suggestionItem
                                tabindex="-1"
                                type="button"
                                class="sh-droppanel__list-action"
                                [class.-sh-unhoverable]="suggestionFocusIndex > -1"
                                (click)="onSelect(suggestion)"
                            >
                                <div class="sh-droppanel__list-action__label">{{ suggestion }}</div>
                            </button>
                        </li>
                    }
                </ul>
            </div>
        }
    }
</ng-template>

<ng-template #inputField>
    <input
        #searchInput
        type="text"
        [formControl]="tagInputControl"
        [id]="id"
        class="sh-input-field sh-form-group__input"
        [class.sh-form-tag-list__inline-input__input-field]="styling.style === 'Embedded'"
        [class.-sh-remove-border]="styling.modifiers.indexOf(formTagListStyleModifier.NoBorder) >= 0"
        (keyup.enter)="onEnter($event)"
        (keyup.backspace)="onBackspace()"
        [attr.placeholder]="placeholder || null"
        [attr.aria-describedBy]="invalid ? describeLabelId : null"
        [attr.aria-invalid]="invalid"
        [attr.autocomplete]="autocomplete"
        [attr.disabled]="disabled ? true : null"
        [maxlength]="_maxLength"
        (focus)="onSearchFocus()"
    />
</ng-template>
